import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import CloseIcon from 'icons/ic-close.svg';
import PropTypes from 'prop-types';

export default function Toast(props) {
  const [visible, setVisible] = useState(false);
  let burnTimer;
  let animationTimer;

  const startBurning = () => {
    setVisible(false);
    animationTimer = setTimeout(() => {
      props.burn(props.toastKey);
    }, 1000);
  };

  useEffect(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    if (props.burnTimer) {
      burnTimer = setTimeout(() => {
        startBurning();
      }, props.burnTimer);
    }
    return () => {
      clearTimeout(burnTimer);
      clearTimeout(animationTimer);
    };
  }, []);

  return (
    <li
      className={classNames(
        'toast tw-border-grey-100 tw-bg-white tw-shadow-md',
        {
          [`toast--${props.modifiers}`]: !!props.modifiers,
        },
        visible ? 'toast--visible' : 'toast--hidden',
      )}
    >
      <div className='toast__content'>{props.contents}</div>
      <CloseIcon
        className='toast__close tw-border-white tw-bg-white hover:tw-border-grey-100'
        height={24}
        onClick={startBurning}
        width={24}
      />
    </li>
  );
}

Toast.propTypes = {
  contents: PropTypes.any.isRequired,
  burnTimer: PropTypes.number,
  burn: PropTypes.func,
};

Toast.defaultProps = {
  burnTimer: 20000,
};
